import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApihelperFunction } from "../../API/ApiHelperFunction";

const initialState = {
    city: [],
    cityStatus:'',
    cityLoader:false,
    cityError:null
};
export const City = createAsyncThunk("/City", async (data) => {
    console.log('function called')
    const response = await ApihelperFunction({
        urlPath: `api/getCity?state_id=${data}`,
        method: "get",
    });
    return response;
});
const citySlice = createSlice({
    name: 'Login',
    initialState,
    reducers: {
        resetState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(City.pending, (state) => {
                state.cityStatus = 'LOADING'
                state.cityLoader = true
                state.cityError = null
            })
            .addCase(City.fulfilled, (state, action) => {
                console.log('action?.payload?.data',action?.payload?.data)
                if (action?.payload?.status) {
                    state.cityStatus = "SUCCESS"
                    state.city = action?.payload?.data
                }
                else {
                    state.cityStatus = "ERROR"
                    state.cityError = [action?.payload?.errors?.[0]]
                }
                state.cityLoader = false
            })
            .addCase(City.rejected, (state, action) => {
                state.cityStatus = 'ERROR'
                state.cityLoader = false
            })
    }
})

export const { resetState } = citySlice.actions;
export default citySlice.reducer;